import { render, staticRenderFns } from "./OvertimeDetail.vue?vue&type=template&id=210c4484&scoped=true"
import script from "./OvertimeDetail.vue?vue&type=script&lang=js"
export * from "./OvertimeDetail.vue?vue&type=script&lang=js"
import style0 from "./OvertimeDetail.vue?vue&type=style&index=0&id=210c4484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c4484",
  null
  
)

export default component.exports